<template>
  <div class="pdf-export-progress" role="status" aria-live="polite">
    <div class="pdf-export-progress__content">
      <div class="pdf-export-progress__status">
        <span class="pdf-export-progress__state" :title="displayState">
          {{ displayState }}
        </span>
        <strong class="pdf-export-progress__percentage">
          {{ normalizedProgress }}%
        </strong>
      </div>

      <div
        class="pdf-export-progress__bar"
        role="progressbar"
        :aria-valuenow="normalizedProgress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <span :style="{ width: `${normalizedProgress}%` }"></span>
      </div>

      <small
        v-if="status === 'processing' && formattedCompletion"
        class="pdf-export-progress__estimate"
      >
        Término estimado: <strong>{{ formattedCompletion }}</strong>
      </small>
    </div>

    <b-spinner small type="border" class="pdf-export-progress__spinner"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "PdfExportProgress",
  props: {
    state: {
      type: String,
      default: ""
    },
    progress: {
      type: [Number, String],
      default: 0
    },
    status: {
      type: String,
      default: "pending"
    },
    expectedCompletionAt: {
      type: [String, Date],
      default: null
    }
  },
  computed: {
    normalizedProgress() {
      const value = Number(this.progress);
      if (!Number.isFinite(value)) {
        return 0;
      }
      return Math.min(100, Math.max(0, Math.round(value)));
    },
    displayState() {
      return this.state || (this.status === "pending" ? "Aguardando para começar..." : "Gerando PDF...");
    },
    formattedCompletion() {
      if (!this.expectedCompletionAt) {
        return null;
      }

      const value = typeof this.expectedCompletionAt === "string"
        ? this.expectedCompletionAt.replace(
          /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})$/,
          "$1T$2"
        )
        : this.expectedCompletionAt;
      const date = value instanceof Date ? value : new Date(value);

      if (Number.isNaN(date.getTime())) {
        return this.expectedCompletionAt;
      }

      return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>
